import React, { useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import LandForm from 'components/Land/LandForm';
import AirForm from 'components/Air/AirForm';
import OceanForm from 'components/Ocean/OceanForm';
import DomesticForm from 'components/Domestic/DomesticForm';
import RailForm from 'components/Rail/RailForm';
import { useTranslation } from "react-i18next";


const TabNavigation = () => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState('3');
  useEffect(() => {
    const tabIds = {
      '1': 'land-tab',
      '2': 'air-tab',
      '3': 'sea-tab',
      '4': 'rail-tab',
      '5': 'domestic-tab'
    };

    const tabElement = document.getElementById(tabIds[activeTab]);
    if (tabElement) {
      tabElement.click();
    }

  }, [activeTab]);

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="e2g-ship-form">
      <div className="e2g-ship-container container bg-white my-5 rounded custom-shadow custom-padding custom-min-height">
        <Nav tabs className='e2g-ship-tabs border-0 position-relative'>
          <NavItem className="e2g-ship-nav-item e2g-ship-nav-sea">
            <NavLink href="#"
              className={classnames('e2g-ship-navlink', 'line-height-4', 'fs-5', 'fw-bold', 'text-dark', 'border-0', 'pb-2', 'px-0', { active: activeTab === '3' })}
              onClick={() => { toggle('3'); }}
            >
              {t("Sea")}
            </NavLink>
          </NavItem>
          <NavItem className="e2g-ship-nav-item e2g-ship-nav-air">
            <NavLink href="#"
              className={classnames('e2g-ship-navlink', 'line-height-4', 'fs-5', 'fw-bold', 'text-dark', 'border-0', 'pb-2', 'px-0', { active: activeTab === '2' })}
              onClick={() => { toggle('2'); }}
            >
              {t("Air")}
            </NavLink>
          </NavItem>
          <NavItem className="e2g-ship-nav-item e2g-ship-nav-land">
            <NavLink href="#"
              className={classnames('e2g-ship-navlink', 'line-height-4', 'fs-5', 'fw-bold', 'text-dark', 'border-0', 'pb-2', 'px-0', { active: activeTab === '1' })}
              onClick={() => { toggle('1'); }}
            >
              {t("Land")}
            </NavLink>
          </NavItem>


          <NavItem className="e2g-ship-nav-item e2g-ship-nav-rail">
            <NavLink href="#"
              className={classnames('e2g-ship-navlink', 'line-height-4', 'fs-5', 'fw-bold', 'text-dark', 'border-0', 'pb-2', 'px-0', { active: activeTab === '4' })}
              onClick={() => { toggle('4'); }}
            >
              {t("Rail")}
            </NavLink>
          </NavItem>
          <NavItem className="e2g-ship-nav-item e2g-ship-nav-domestic">
            <NavLink href="#"
              className={classnames('e2g-ship-navlink', 'line-height-4', 'fs-5', 'fw-bold', 'text-dark', 'border-0', 'pb-2', 'px-0', { active: activeTab === '5' })}
              onClick={() => { toggle('5'); }}
            >
              {t("Irish Domestic")}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent className="e2g-ship-tab-content" activeTab={activeTab}>
          <TabPane className="e2g-ship-tab-pane" tabId="1">
            <Row>
              <Col sm="12">
                <LandForm />
              </Col>
            </Row>
          </TabPane>
          <TabPane className="e2g-ship-tab-pane" tabId="2">
            <Row>
              <Col sm="12">
                <AirForm />
              </Col>
            </Row>
          </TabPane>
          <TabPane className="e2g-ship-tab-pane" tabId="3">
            <Row>
              <Col sm="12">
                <OceanForm />
              </Col>
            </Row>
          </TabPane>
          <TabPane className="e2g-ship-tab-pane" tabId="4">
            <Row>
              <Col sm="12">
                <RailForm />
              </Col>
            </Row>
          </TabPane>
          <TabPane className="e2g-ship-tab-pane" tabId="5">
            <Row>
              <Col sm="12">
                <DomesticForm />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
}

export default TabNavigation;